<template lang="pug">
div(@click="$router.push(episodePath)"
  :style="borderStyle").wrap-item-edit-comic-episode-list.f.fm.flex-between.pl10.py8.cursor-pointer
  div.wrap-info.w-full
    div.f.fm.flex-between.mb4
      div.f.fm
        span.fz14.block.line-clamp-1.mr10 {{episode.title}}
        //- div(@click.stop="onStatusLabel").f.fm
        div
          span.status.fz11 {{statusLabel}}
          a(:href="postURL" target="_blank" @click.stop)
            v-icon(v-if="'public' == episode.status" size="16px").pt1.ml4 mdi-open-in-new
      v-menu(offset-y)
        template(v-slot:activator="{ on }")
          v-icon(v-on="on") mdi-dots-vertical
        template
          div.more-window.px16.py10
            span(v-if="episode.status === 'public'"
              @click="onPrivate").fz14.block.mb4.cursor-pointer.white-space-nowrap 非公開
            span(@click="onDelete").c-dangerous.fz14.block.cursor-pointer.white-space-nowrap 削除
    span.label-updated-at.fz12.mb4.block 更新日時：{{updatedAtLabel}}
    div(v-if="episode.status == 'public'").wrap-stats.relative.f.fm.h20.pl1
      div.absolute.f.fm
        v-icon(:color="pallete.$gray_color" size="14").mr5 mdi-eye-outline
        span.fz12 {{episode.pageViewNum ? numStr(episode.pageViewNum) : ''}}
      div.absolute.l40.f.fm
        v-icon(:color="pallete.$gray_color" size="14").mr5 mdi-heart-outline
        span.fz12 {{episode.likeNum ? numStr(episode.likeNum) : ''}}
      div.absolute.l80.f.fm
        v-icon(:color="pallete.$gray_color" size="14").mr5.pt2 mdi-comment-outline
        span.fz12 {{episode.commentNum ? numStr(episode.commentNum) : ''}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-edit-comic-episode-list {
  border-bottom: $basic_border;
  .wrap-info {
    .status {
      color: $secondary_text_color;
    }
    .label-updated-at {
      color: $secondary_text_color;
    }
    .wrap-stats {
      color: $gray_color;
    }
  }
}
</style>

<script>
import { domain } from '@/components/utils/config'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import { formatDistance } from 'date-fns'
import ja from 'date-fns/locale/ja'

export default {
  props: {
    episode: {
      type: Object,
      required: true
    },
    episodes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isSaving: false
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    statusLabel () {
      switch (this.episode.status) {
        case 'draft':
          return '下書き'
        case 'public':
          return '公開中'
        case 'private':
          return '非公開'
      }
      return ''
    },
    statusColor () {
      switch (this.episode.status) {
        case 'draft':
          return this.pallete.$safe_color
        case 'public':
          return this.pallete.$green_color
        case 'private':
          return this.pallete.$secondary_bg_color
      }
      return ''
    },
    borderStyle () {
      return `border-left: solid ${this.statusColor} 4px;`
    },
    updatedAtLabel () {
      return formatDistance(new Date(), this.episode.updatedAt.toDate(), { locale: ja }) + '前'
    },
    episodePath () {
      const rp = this.$route.params
      return `/edit-comic/${rp.comicId}/${this.episode.id}/${this.episode.currentPage}`
    },
    postURL () {
      return `${domain}/post/${this.episode.postId}`
    }
  },
  methods: {
    async onPrivate () {
      // alert('Under Construction')
      const go = await window.customConfirm('エピソードを非公開にしますか？')
      if (this.isSaving || !go) return
      this.isSaving = true

      const comicId = this.$route.params.comicId
      await database.episodeCollection(comicId)
        .update(this.episode.id, { status: 'private' })
      await database.postCollection()
        .update(this.episode.postId, { status: 'private' })
      await database.comicCollection().decrementPublicEpisodeNum(comicId)

      this.$emit('updateEpisodes')
      this.$root.$emit('showNavigationMessage', {
        message: '非公開にしました', showOK: true
      })

      await this.sleep(400)
      this.isSaving = false
    },
    async onDelete () {
      const go = await window.customConfirm('削除しますか？ * この操作は取り消せません')
      if (this.isSaving || !go) return
      this.isSaving = true

      const comicId = this.$route.params.comicId

      const prevEpisode = this.episodes
        .filter(e => e.id === this.episode.prev)[0]
      const nextEpisodes = this.episodes
        .filter(e => e.prev === this.episode.id)

      if (prevEpisode && nextEpisodes[0]) {
        // 次のエピソードのprevを一個前のエピソードにする
        const promises = nextEpisodes.map(n => {
          return database.episodeCollection(comicId)
            .update(n.id, { prev: prevEpisode.id })
        })
        await Promise.all(promises)
      } else if (!prevEpisode && nextEpisodes[0]) {
        // これよりも前のエピソードがない場合（ルートのエピソードの場合）
        // かつ次のエピソードがある場合は直近の次のエピソードをルートのエピソードにする
        const newRootEpisode = nextEpisodes[0]
        await database.episodeCollection(comicId)
          .deleteField(newRootEpisode.id, 'prev')
      }
      
      await database.episodeCollection(comicId).delete(this.episode.id)
      
      if (this.episode.status === 'public') {
        await database.comicCollection().decrementPublicEpisodeNum(comicId)
      }

      if (this.episode.postId) {
        await database.postCollection().delete(this.episode.postId)
      }

      this.$emit('updateEpisodes')

      this.$root.$emit('showNavigationMessage', {
        message: '削除しました', showOK: true
      })
      this.isSaving = false
    }
  }
}
</script>
